import LegalLayout from "@/components/LegalLayout";

export default function Tietosuoja() {
  return (
    <LegalLayout title="Tietosuojaseloste" updated="kesäkuu 2026">
      <p>
        Tässä selosteessa kuvataan, miten Lahden Autokulma (Tepe Markkinointi Oy){" "}
        käsittelee henkilötietoja EU:n yleisen tietosuoja-asetuksen (GDPR) mukaisesti.
      </p>

      <div>
        <h2>1. Rekisterinpitäjä</h2>
        <ul>
          <li>Tepe Markkinointi Oy (Lahden Autokulma), Y-tunnus 1557725-9</li>
          <li>Äijälänkatu 3, 15700 Lahti</li>
          <li>Yhteyshenkilö tietosuoja-asioissa: Teijo Paakkari, teijo.paakkari@lahdenautokulma.fi</li>
        </ul>
      </div>

      <div>
        <h2>2. Mitä tietoja keräämme</h2>
        <p>Keräämme vain tiedot, jotka annat itse asioidessasi kanssamme:</p>
        <ul>
          <li>Chat-keskustelu: nimi, puhelinnumero tai sähköposti sekä viestisi sisältö</li>
          <li>Yhteydenotto- ja vaihtoautolomake: nimi, sähköposti, puhelin, tiedot autostasi ja viesti</li>
          <li>Verkkosivujen käyttöön liittyvät tekniset tiedot ja evästeet (ks. Evästekäytäntö)</li>
        </ul>
      </div>

      <div>
        <h2>3. Käsittelyn tarkoitus ja oikeusperuste</h2>
        <ul>
          <li>Yhteydenottopyyntöihin vastaaminen ja asiakaspalvelu — oikeusperuste: suostumus / oikeutettu etu</li>
          <li>Autokauppaan ja rahoitukseen liittyvä asiointi — oikeusperuste: sopimuksen valmistelu</li>
          <li>Analytiikka ja markkinointi vain suostumuksellasi (evästeet)</li>
        </ul>
      </div>

      <div>
        <h2>4. Tietojen säilytysaika</h2>
        <p>
          Säilytämme tietoja vain niin kauan kuin on tarpeen yllä mainittuihin tarkoituksiin,
          enintään 24 kuukautta viimeisimmästä yhteydenotosta, ellei
          laki edellytä pidempää säilytystä.
        </p>
      </div>

      <div>
        <h2>5. Tietojen vastaanottajat</h2>
        <p>
          Emme myy tietojasi. Käytämme luotettavia palveluntarjoajia mm. verkkosivujen ylläpitoon
          ja sähköposti- ilmoituksiin. Tietoja voidaan luovuttaa rahoitusyhtiöille vain
          rahoitushakemuksen yhteydessä suostumuksellasi (Santander, LähiTapiola, Bigbank, Svea Autorahoitus).
        </p>
      </div>

      <div>
        <h2>6. Oikeutesi</h2>
        <p>Sinulla on oikeus tarkastaa, oikaista ja poistaa tietosi sekä rajoittaa ja vastustaa käsittelyä.
          Voit myös peruuttaa suostumuksesi milloin tahansa. Pyynnöt: teijo.paakkari@lahdenautokulma.fi.</p>
        <p>
          Sinulla on oikeus tehdä valitus valvontaviranomaiselle: Tietosuojavaltuutetun toimisto,{" "}
          <a href="https://tietosuoja.fi" target="_blank" rel="noreferrer">tietosuoja.fi</a>.
        </p>
      </div>
    </LegalLayout>
  );
}
